import React, { Component } from 'react';
import { motion } from 'framer-motion';
import StarStory from '../components/StarStory';
import AnimatedCounter from '../components/AnimatedCounter';
const RapToBeatsPage = () => {
  return <div className="bg-white min-h-screen" data-id="element-373">
      <div className="container mx-auto px-4 py-16" data-id="element-374">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 mb-12" data-id="element-375">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rdfB7fVVxZg9cnFNHjimw6/1630501186342.jpg" alt="Rap to Beats logo" className="w-24 h-24 object-contain" data-id="element-376" />
          <div data-id="element-377">
            <motion.h1 className="text-4xl font-bold text-gray-800 mb-2" initial={{
            opacity: 0.5
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5
          }} data-id="element-378">
              Co-Founder & Product Lead at Rap to Beats
            </motion.h1>
            <motion.p className="text-xl text-gray-700 mb-4" initial={{
            opacity: 0.5
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-379">
              2011 — 2014
            </motion.p>
            <motion.div className="bg-gray-100 p-4 rounded-lg" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-380">
              <p className="text-gray-700" data-id="element-381">
                <span className="font-bold" data-id="element-382">Context:</span> Early iOS social
                music creation app. Pioneered user-generated content in music.
              </p>
            </motion.div>
          </div>
        </div>
        {/* STAR Stories */}
        <StarStory title="Product-Market Fit Discovery" situation="The music creation space was dominated by professional tools like GarageBand. No solution existed for casual music creators who wanted to make and share rap songs." task="As co-founder, I needed to identify and validate a product concept that would resonate with casual music creators." action="I led a series of rapid prototyping cycles, testing 12 different concepts with target users. We identified that freestyle rapping over beats was the most engaging interaction. I designed a simple interface where users could browse beats, record vocals, and share creations. We launched a beta with 500 users and iterated based on usage patterns." result="We achieved product-market fit with a 62% D1 retention rate and 41% D7 retention, far exceeding mobile app benchmarks. This validation helped us secure $1.2M in seed funding." imageUrl="https://via.placeholder.com/600x400?text=Rap+to+Beats+App" imageAlt="Rap to Beats app interface showing beat selection screen" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-384">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-385">
                Retention Metrics
              </h4>
              <div className="flex justify-between items-center mb-2" data-id="element-386">
                <span className="text-gray-700" data-id="element-387">D1 Retention:</span>
                <AnimatedCounter start={0} end={62} suffix="%" data-id="element-388" />
              </div>
              <div className="flex justify-between items-center" data-id="element-389">
                <span className="text-gray-700" data-id="element-390">D7 Retention:</span>
                <AnimatedCounter start={0} end={41} suffix="%" data-id="element-391" />
              </div>
            </div>} data-id="element-383" />
        <StarStory title="User Growth Acceleration" situation="After initial traction, we needed to scale beyond word-of-mouth growth. The app store was becoming increasingly competitive." task="Scale from 50K to 300K monthly active users without exceeding our limited marketing budget." action="I implemented a viral sharing loop where users could share their creations to social platforms with one tap. We added in-app challenges and contests to drive engagement. I also built partnerships with emerging hip-hop artists to create exclusive beats for our platform, driving organic PR. We optimized our App Store listing with A/B tested screenshots and descriptions." result="MAU grew from 50K to 300K within 8 months. User acquisition cost dropped from $2.10 to $0.75 per user. The app reached #3 in the Music category on the App Store." imageUrl="https://via.placeholder.com/600x400?text=User+Growth+Chart" imageAlt="Growth chart showing user acquisition over time" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-393">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-394">
                Growth Metrics
              </h4>
              <div className="flex justify-between items-center mb-2" data-id="element-395">
                <span className="text-gray-700" data-id="element-396">MAU Growth:</span>
                <div className="flex items-center" data-id="element-397">
                  <span className="text-gray-500 mr-2" data-id="element-398">50K</span>
                  <span className="text-gray-700 mx-2" data-id="element-399">→</span>
                  <AnimatedCounter start={50} end={300} suffix="K" data-id="element-400" />
                </div>
              </div>
              <div className="flex justify-between items-center" data-id="element-401">
                <span className="text-gray-700" data-id="element-402">CAC Reduction:</span>
                <div className="flex items-center" data-id="element-403">
                  <span className="text-gray-500 mr-2" data-id="element-404">$2.10</span>
                  <span className="text-gray-700 mx-2" data-id="element-405">→</span>
                  <AnimatedCounter start={2.1} end={0.75} prefix="$" decimals={2} data-id="element-406" />
                </div>
              </div>
            </div>} data-id="element-392" />
        <StarStory title="Monetization Strategy" situation="We had strong user growth but no revenue model. Investors were pushing for monetization without sacrificing growth." task="Implement a sustainable monetization strategy while maintaining user growth and engagement metrics." action="I designed a freemium model with premium beat packs and advanced audio effects. We introduced a subscription tier that unlocked all content and removed recording time limits. I structured pricing tiers based on user segmentation and conducted willingness-to-pay studies. We also built a marketplace where beat producers could sell their creations with revenue sharing." result="Achieved 8% conversion to paid users, generating $480K ARR within 6 months. User growth continued at 15% month-over-month despite the monetization changes." imageUrl="https://via.placeholder.com/600x400?text=Monetization+Dashboard" imageAlt="Monetization dashboard showing revenue growth" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-408">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-409">
                Monetization Results
              </h4>
              <div className="flex justify-between items-center mb-2" data-id="element-410">
                <span className="text-gray-700" data-id="element-411">Paid Conversion:</span>
                <AnimatedCounter start={0} end={8} suffix="%" data-id="element-412" />
              </div>
              <div className="flex justify-between items-center" data-id="element-413">
                <span className="text-gray-700" data-id="element-414">Annual Revenue:</span>
                <AnimatedCounter start={0} end={480} prefix="$" suffix="K" data-id="element-415" />
              </div>
            </div>} data-id="element-407" />
        {/* Testimonial */}
        <motion.div className="mt-16 bg-gray-100 p-8 rounded-lg" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-416">
          <p className="text-xl text-gray-700 italic mb-4" data-id="element-417">
            "Aakash scaled our app to 300K MAU, pioneering social music creation
            on iOS."
          </p>
          <p className="text-gray-800 font-bold" data-id="element-418">
            — James Dean, Founding Engineer
          </p>
        </motion.div>
      </div>
    </div>;
};
export default RapToBeatsPage;